import { formatOfferingAmountOption } from '../utils';

const accountSelectors = {
  getAccountId: state => state.account.accountId,
  getAccountData: state => state.account,
  selectRegulationsUrl: state => state.account.getRegulations,
  selectMassOfferingAmountOption: state => {
    const massOfferingAmountOption = state.account.massOfferingAmount;
    return formatOfferingAmountOption(massOfferingAmountOption);
  },
  selectDonationAmountOption: state => {
    const donationAmountOption = state.account.donationAmount;
    return formatOfferingAmountOption(donationAmountOption);
  },
  isDonateConfirmation: state => !!Number(state.account.isDonateConfirmation),
};

export default accountSelectors;
